import { useAtomValue } from "jotai";
import type { FunctionComponent } from "react";
import { useEffect, useState } from "react";
import { Modal } from "scmp-sdk";

import { rosettaAtom } from "scmp-app/lib/rosetta";

import IconArchive from "./icon-archive.svg";
import IconDailyPulse from "./icon-daily-plus.svg";
import IconFactSheet from "./icon-flat-sheet.svg";
import IconNewsAgenda from "./icon-news-agenda.svg";
import {
  Backdrop,
  BenefitsList,
  Container,
  ContainerContent,
  Divider,
  FooterMessage,
  Header,
  Headline,
  StartExploringButton,
  StyledPlusLogo,
  SubHeadline,
} from "./styles";

export const PlusWelcomePopup: FunctionComponent = () => {
  const asyncRosettaState = useAtomValue(rosettaAtom);
  const rosettaInstance = asyncRosettaState?.result?.instance;
  const showSCMPPlusWelcomePopup = rosettaInstance?.rulesEngine.getOutcome(
    "ui.popup.showSCMPPlusWelcomePopup",
  );

  const [isOpened, setIsOpened] = useState(false);

  useEffect(() => {
    if (!showSCMPPlusWelcomePopup || !rosettaInstance) return;

    setIsOpened(true);
    void rosettaInstance
      ?.getService("pianoUserInfo")
      ?.updatePianoUserHasShownSCMPPlusWelcomePopUpField(true);
  }, [rosettaInstance, showSCMPPlusWelcomePopup]);

  return (
    <Modal
      BackdropComponent={Backdrop}
      onClose={(_, reason) => reason !== "backdropClick" && setIsOpened(false)}
      open={isOpened}
    >
      <Container>
        <StyledPlusLogo />
        <ContainerContent>
          <Header>
            <Headline>Welcome to SCMP Plus</Headline>
            <SubHeadline>Get started by browsing our content sections</SubHeadline>
          </Header>
          <Divider />
          <BenefitsList>
            <li>
              <IconDailyPulse />
              <p>
                Read the latest edition of our newsletter, the <b>Daily Pulse</b>
              </p>
            </li>
            <li>
              <IconNewsAgenda />
              <p>
                Explore upcoming China-centric events with <b>News Agenda</b>
              </p>
            </li>
            <li>
              <IconFactSheet />
              <p>
                Navigate complex data in a visually compelling way with <b>FactSheet</b>
              </p>
            </li>
            <li>
              <IconArchive />
              <p>
                Browse our collection of past content in the <b>SCMP Plus archive</b>
              </p>
            </li>
          </BenefitsList>
          <Divider />
          <FooterMessage>
            Stay tuned for new features, including exclusive columns, an enhanced archive and search
            as well as interactive infographics.
          </FooterMessage>
        </ContainerContent>
        <StartExploringButton onClick={() => setIsOpened(false)}>
          START EXPLORING
        </StartExploringButton>
      </Container>
    </Modal>
  );
};

PlusWelcomePopup.displayName = "PlusWelcomePopup";
